<template>
  <el-dialog :title="'公司权限 — ' + (user.nickName || user.username || '')"
             :visible="true" width="706px" top="8vh" append-to-body
             :close-on-click-modal="false" :close-on-press-escape="!saving" :show-close="!saving" @close="close">
    <div v-loading="loading" class="permission-content">
      <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon />
      <el-alert v-else-if="administrator" title="管理员默认拥有全部权限，无需配置。" type="info" :closable="false" show-icon />
      <template v-else-if="loaded">
        <el-tree ref="tree" :data="tree" node-key="id" show-checkbox
                 default-expand-all :props="{ children: 'children', label: 'name', disabled: () => saving }"
                 class="permission-tree">
          <span slot-scope="{ data }" class="permission-node">
            <img :src="data.deptType == 1 ? require('../../../../assets/img/companyiocn.svg') : require('../../../../assets/img/nodeicon.svg')" />
            <span>{{ data.name }}</span>
          </span>
        </el-tree>
      </template>
    </div>
    <span slot="footer">
      <el-button :disabled="saving" @click="close">返回</el-button>
      <el-button v-if="error" @click="load">重试</el-button>
      <el-button v-if="!administrator" type="primary" :loading="saving" :disabled="!loaded || loading || !!error" @click="save">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { DeptTreeTableList } from '@/api/permissionManagement';
import { getUserDataPermission, saveUserDataPermission } from '@/api/userDataPermission';

export default {
  name: 'UserDataPermissionDialog',
  props: { user: { type: Object, required: true } },
  data() { return { tree: [], savedIds: [], administrator: false, loaded: false, loading: false, saving: false, error: '', requestId: 0 }; },
  created() { this.load(); },
  beforeDestroy() { this.requestId++; },
  methods: {
    close() { if (!this.saving) this.$emit('close'); },
    async load() {
      const version = ++this.requestId;
      this.loading = true;
      this.loaded = false;
      this.error = '';
      try {
        const permission = await getUserDataPermission(this.user.userId);
        if (version !== this.requestId) return;
        this.administrator = permission.administrator;
        this.savedIds = permission.deptIds || [];
        if (!this.administrator) {
          const response = await DeptTreeTableList();
          if (version !== this.requestId) return;
          if (!response || !response.data || response.data.code !== 1) throw new Error('组织树加载失败，请重试');
          this.tree = response.data.data || [];
        }
        this.loaded = true;
        await this.$nextTick();
        if (this.$refs.tree) this.$refs.tree.setCheckedKeys(this.savedIds);
      } catch (error) {
        if (version === this.requestId) this.error = error.message || '公司权限加载失败';
      } finally {
        if (version === this.requestId) this.loading = false;
      }
    },
    async save() {
      if (this.saving || !this.loaded || this.administrator || this.error) return;
      this.saving = true;
      try {
        const deptIds = this.$refs.tree.getCheckedKeys();
        // 保留当前配置人不可见的已授权节点，避免保存时悄悄丢失其他节点。
        this.savedIds.forEach(id => {
          if (!this.$refs.tree.getNode(id) && !deptIds.includes(id)) deptIds.push(id);
        });
        await saveUserDataPermission({ userId: this.user.userId, dataScope: '2', deptIds });
        this.$message.success('公司权限保存成功');
        this.$emit('close');
      } catch (error) { this.$message.error(error.message || '公司权限保存失败'); }
      finally { this.saving = false; }
    }
  }
};
</script>

<style scoped>
.permission-content { min-height: 100px; max-height: 60vh; overflow: auto; }
.permission-tree { margin-top: 0; }
.permission-node { display: flex; align-items: center; gap: 5px; }
.permission-node img { width: 16px; height: 16px; }
</style>
